/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnDestroy} from '@angular/core';
import {AuthService, AuthStateService, RedirectService, SignInComponent} from 'compob2b-auth';
import {CompoApiService} from 'compob2b-libs';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-sign-in',
    templateUrl: './admin-sign-in.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AdminSignInComponent extends SignInComponent implements OnDestroy {

  private uriSub: Subscription;
  uri = this.redirect.getUri();

  constructor(private readonly adminApiService: CompoApiService,
              private readonly authService: AuthService,
              private readonly adminStateService: AuthStateService,
              private readonly router: Router,
              private readonly redirect: RedirectService
  ) {

    super(adminApiService, authService, adminStateService);
  }

  /**
   * Override method
   */
  afterSignIn(): void {
    this.uriSub = this.redirect.getUri().pipe(take(1)).subscribe(uri => {

      if (this.authService.isClient()) {
        this.router.navigate(['cabinet', 'crm', 'project']);
      } else if (uri !== null && uri !== undefined && uri.length > 0) {
        this.router.navigateByUrl(uri);
        this.redirect.next(null);
      } else {
        this.router.navigate(['cabinet']);
      }

    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.uriSub) {
      this.uriSub.unsubscribe();
    }
  }

}
